import React, { useEffect } from 'react'

import { LntInput } from '@app/components/base'
import { RendererWrapper } from '@app/components/renderers'

import { SIZE } from '@app/constants'
import { MONITORING_PRODUCT_STATUS } from '@app/api/constants'
import { isEmptyString } from '@app/utils'

import type { UseHowToMonitorColumnParams } from './types'

export const useHowToMonitorColumn = ({ columns, patchFn }: UseHowToMonitorColumnParams): void => {
  useEffect(() => {
    const howToMonitorColumn = columns.find(column => column.key === 'howToMonitor')

    if (howToMonitorColumn) {
      howToMonitorColumn.render = (_, { howToMonitor, id: productId, status }) => {
        return (
          <RendererWrapper
            minWidth={ 200 }
            maxWidth={ 250 }
          >
            <LntInput
              key={ `${productId}_${howToMonitor}` }
              placeholder='Введите текст'
              disabled={ status === MONITORING_PRODUCT_STATUS.DELETED }
              size={ SIZE.small }
              defaultValue={ howToMonitor }
              onBlur={ event => {
                const value = event.target.value

                if (isEmptyString(value)) return

                patchFn({
                  productId,
                  howToMonitor: value
                })
              } }
            />
          </RendererWrapper>
        )
      }
    }
  }, [patchFn])
}
